import { mapMutations, mapActions } from 'vuex';

export default {
  methods: {
    ...mapMutations(['setActivePopoverChat']),
    ...mapActions(['getConversationInfo', 'errorNotify']),
    openPopoverChat(userId) {
      return this.getConversationInfo({ conversationId: userId })
        .then(({ id }) => {
          this.setActivePopoverChat(id);
        })
        .catch(this.errorNotify);
    },
  },
};
